<!--
 * @Author: bashuang
 * @Date: 2023-11-9
 * @Description: 关于我们页面-公司介绍
-->
<template>
  <div class="companyProfile">
    <div class="module-tit">{{ '公司简介' | sLang }}</div>
    <div class="intro-wrap">
      <div class="intro-tit">{{ '汇达（香港）保险经纪' | sLang }}</div>
      <div class="intro-con intro-con1">{{ '匯達(香港)保險經紀有限公司成立於2015年4月，是一間位於香港的持牌保險經紀公司（IA牌照號碼FB1757），獲香港專業保險經紀協會授予牌照（號碼M0651），香港保險中介人商會授予牌照（號碼FM2121）。' | sLang }}</div>
      <div class="intro-con intro-con2">{{ '秉持“立足香港、服務全球”的發展格局，匯達致力於成爲高淨值客戶羣體最青睞的保險綜合服務平臺，爲個人和家庭提供多元化的綜合保障及金融規劃服務，以滿足每位客戶獨特需求和財務目標，爲客戶提供從創富傳承、健康保障到品質生活的完善人生規劃。' | sLang }}</div>
      <myImgLazy class="intro-photo" :src="require('@/assets/img/aboutUs/intro_photo.jpeg')"  alt="匯達(香港)保險經紀" title="匯達(香港)保險經紀"></myImgLazy>
    </div>
  </div>
</template>

<script>
import myImgLazy from "@/components/myImgLazy/index.vue"
export default {
  name: 'companyProfile',
  props: {
    title: '',
  },
  components: {
    myImgLazy
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
.companyProfile {
  width: 100%;
  .module-tit{
    font-size: 0.22rem;
    // font-family: HiraginoSansGB-W5, HiraginoSansGB;
    font-weight: 500;
    color: #333333;
    margin-bottom: 0.30rem
  }
  .intro-wrap{
    padding: 0.31rem 4.50rem 0.31rem 0.24rem;
    width: 7.80rem;
    height: 3.55rem;
    background: #F7F8FA;
    position: relative;
    .intro-tit{
      height: 0.26rem;
      font-size: 0.14rem;
      // font-family: HiraginoSansGB-W6, HiraginoSansGB;
      font-weight: 600;
      color: #333333;
      position: relative;
      line-height: 0.18rem;
      &::after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 0.16rem;
        height: 0.02rem;
        background: #333333;
      }
    }
    .intro-con{
      font-size: 0.14rem;
      // font-family: HiraginoSansGB-W3, HiraginoSansGB;
      font-weight: normal;
      color: #333333;
      line-height: 0.26rem;
      text-align: justify;
      transform: scale(0.8);
      transform-origin: left
    }
    .intro-con1{
      border-bottom: 0.01rem solid #D8D8D8;
      padding: 0 0 0.22rem;
    }
    .intro-con2{
      margin-top: -0.15rem;
    }
    .intro-photo{
      position: absolute;
      width: 4.60rem;
      right: -0.4rem;
      top: 0.30rem;
    }
  }
}
</style>